import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Calendar,
  Trophy,
  Award,
  Globe,
  ArrowRight,
  Dna,
  FlaskConical,
  GitMerge,
  Cpu
} from 'lucide-react';

export default function FeaturedEvents() {
  return (
    <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 20px 60px', position: 'relative', zIndex: 1 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
        className="cb-featured-card"
      >
        <div className="cb-featured-grid">
          <Link
            to="/events/scisprint-2026"
            className="cb-featured-media-col"
            title="Click to view full SciSprint 2026 event details"
          >
            <img
              src="/scisprint2026_poster.jpg"
              alt="SciSprint 2026 Hackathon Poster Visual"
              className="cb-featured-poster-img"
            />
          </Link>

          <div className="cb-featured-info-col">
            <div>
              <div style={{ marginBottom: '14px' }}>
                <Link
                  to="/events/scisprint-2026"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <h2
                    style={{
                      fontFamily: "'Space Grotesk', -apple-system, sans-serif",
                      fontSize: 'clamp(2.1rem, 3.2vw, 2.85rem)',
                      fontWeight: 900,
                      lineHeight: 1.05,
                      letterSpacing: '-0.04em',
                      color: '#0f172a',
                      margin: '0 0 6px',
                      transition: 'color 0.2s ease'
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#4F1985')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = '#0f172a')}
                  >
                    SciSprint{' '}
                    <span
                      style={{
                        background: 'linear-gradient(135deg, #170d2b 0%, #4F1985 45%, #9047ff 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        display: 'inline-block'
                      }}
                    >
                      2026
                    </span>
                  </h2>
                </Link>

                <div
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontSize: 'clamp(1.05rem, 1.4vw, 1.25rem)',
                    fontWeight: 750,
                    color: '#4F1985',
                    letterSpacing: '-0.02em',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    flexWrap: 'wrap'
                  }}
                >
                  <span>Agent Scientist Hackathon Series</span>
                  <span
                    style={{
                      fontFamily: "'JetBrains Mono', monospace",
                      fontSize: '10px',
                      fontWeight: 800,
                      color: '#059669',
                      backgroundColor: 'rgba(16, 185, 129, 0.1)',
                      border: '1px solid rgba(16, 185, 129, 0.25)',
                      padding: '2px 8px',
                      borderRadius: '9999px',
                      letterSpacing: '0.04em',
                      textTransform: 'uppercase'
                    }}
                  >
                    Active
                  </span>
                </div>
              </div>

              <p
                style={{
                  fontSize: '14px',
                  color: '#475569',
                  lineHeight: 1.65,
                  margin: '0 0 20px',
                  fontWeight: 450
                }}
              >
                Four Weeks. Four Scientific Domains. Twelve Real World Research Challenges. One Scientific Revolution. Experience hands-on computational biology workflows and autonomous agent discovery powered by Agent Scientist and ChemBio AI.
              </p>

              <div className="cb-featured-tracks">
                {[
                  { week: '01', name: 'Protein Forge', domain: 'Protein Engineering', icon: <Dna size={15} color="#7c3aed" />, accent: '#7c3aed', bg: '#f5f3ff', border: 'rgba(124, 58, 237, 0.2)' },
                  { week: '02', name: 'Molecule Masters', domain: 'Small Molecule', icon: <FlaskConical size={15} color="#0284c7" />, accent: '#0284c7', bg: '#f0f9ff', border: 'rgba(2, 132, 199, 0.2)' },
                  { week: '03', name: 'Synthesis X', domain: 'Synthetic Chemistry', icon: <GitMerge size={15} color="#059669" />, accent: '#059669', bg: '#ecfdf5', border: 'rgba(5, 150, 105, 0.2)' },
                  { week: '04', name: 'RNA Recode', domain: 'RNA Design', icon: <Cpu size={15} color="#e11d48" />, accent: '#e11d48', bg: '#fff1f2', border: 'rgba(225, 29, 72, 0.2)' }
                ].map((track, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 12px',
                      borderRadius: '14px',
                      backgroundColor: '#ffffff',
                      border: `1.5px solid ${track.border}`,
                      boxShadow: '0 2px 8px -2px rgba(15, 23, 42, 0.04)',
                      transition: 'transform 0.2s ease'
                    }}
                  >
                    <div
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '10px',
                        backgroundColor: track.bg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      {track.icon}
                    </div>
                    <div style={{ minWidth: 0, overflow: 'hidden' }}>
                      <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '9px', fontWeight: 800, color: track.accent, letterSpacing: '0.04em' }}>
                        WEEK {track.week}
                      </div>
                      <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '13px', fontWeight: 800, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {track.name}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="cb-featured-metrics">
                {[
                  {
                    label: 'Dates',
                    val: '9 Nov – 6 Dec 2026',
                    icon: <Calendar size={17} color="#7c3aed" strokeWidth={2.2} />,
                    accent: '#7c3aed',
                    bg: '#f5f3ff',
                    border: 'rgba(124, 58, 237, 0.2)'
                  },
                  {
                    label: 'Prize Pool',
                    val: 'INR 8,000 Rewards',
                    icon: <Trophy size={17} color="#d97706" strokeWidth={2.2} />,
                    accent: '#d97706',
                    bg: '#fffbeb',
                    border: 'rgba(217, 119, 6, 0.25)'
                  },
                  {
                    label: 'Recognition',
                    val: 'Certificates for All',
                    icon: <Award size={17} color="#4F1985" strokeWidth={2.2} />,
                    accent: '#4F1985',
                    bg: '#f3e8ff',
                    border: 'rgba(79, 25, 133, 0.2)'
                  },
                  {
                    label: 'Format',
                    val: '100% Online • Global',
                    icon: <Globe size={17} color="#0284c7" strokeWidth={2.2} />,
                    accent: '#0284c7',
                    bg: '#f0f9ff',
                    border: 'rgba(2, 132, 199, 0.2)'
                  }
                ].map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      minWidth: 0
                    }}
                  >
                    <div
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '10px',
                        backgroundColor: item.bg,
                        border: `1.5px solid ${item.border}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}
                    >
                      {item.icon}
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: '10px',
                          fontFamily: "'JetBrains Mono', monospace",
                          fontWeight: 750,
                          color: '#64748b',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          lineHeight: 1.2,
                          marginBottom: '2px'
                        }}
                      >
                        {item.label}
                      </div>
                      <div
                        style={{
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontSize: '13px',
                          fontWeight: 800,
                          color: '#0f172a',
                          lineHeight: 1.25,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                      >
                        {item.val}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="cb-featured-actions">
              <Link
                to="/events/scisprint-2026"
                className="glossy-btn-primary glossy-btn-sheen"
                style={{
                  width: '100%',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  color: '#ffffff',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: '14.5px',
                  fontWeight: 800,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  boxShadow: '0 10px 28px -4px rgba(79, 25, 133, 0.42)'
                }}
              >
                <span>Explore SciSprint 2026 Page</span>
                <ArrowRight size={17} />
              </Link>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
